import { Component } from '@angular/core';
import { NavigationError, ResolveEnd, ResolveStart, Router } from '@angular/router';
import { filter, mapTo, merge, Observable } from 'rxjs';
import { LocalisationLanguageService } from './services/localisation-language.service';
import { APP_VERSION } from './version';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  version = APP_VERSION;
  translations!: string[];

  // Loader management
  private _showLoaderEvents$!: Observable<boolean>;
  private _hideLoaderEvents$!: Observable<boolean>;
  public isLoading$!: Observable<boolean>;

  constructor(
    private localisationLanguageService: LocalisationLanguageService,
    private router: Router
  ) { }

  async ngOnInit() {
    // Catch resolver for auto loading
    this._showLoaderEvents$ = this.router.events.pipe(
      filter(e => e instanceof ResolveStart),
      mapTo(true)
    );

    this._hideLoaderEvents$ = this.router.events.pipe(
      // tap( (e) => console.log(e)),
      filter(e => { return (e instanceof ResolveEnd || e instanceof NavigationError) }),
      mapTo(false)
    );
    this.isLoading$ = merge(this._showLoaderEvents$, this._hideLoaderEvents$);
    this.localisationLanguageService.initLanguages();

  }
}
